import { render, staticRenderFns } from "./SemestrePage.vue?vue&type=template&id=34e5bf1f"
import script from "./SemestrePage.js?vue&type=script&lang=js&external"
export * from "./SemestrePage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports